(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ssa-charms-atelier"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ssa-charms-atelier')) {
  customElements.define('ssa-charms-atelier', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const filters = this.querySelector('.ca-filters');
      if (filters) {
        filters.hidden = false;
        filters.addEventListener('click', event => {
          const button = event.target.closest('button[data-mood]');
          if (!button) return;
          const apply = () => {
            filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            let count = 0;
            this.querySelectorAll('.ca-card').forEach(card => {
              card.hidden = !card.dataset.moods.split(' ').includes(button.dataset.mood);
              if (!card.hidden) count++;
            });
            this.querySelector('.ca-count').textContent = `${count} ${this.dataset.resultLabel}`;
            this.querySelector('.ca-no-results').hidden = count > 0;
          };
          if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(apply);
          else apply();
        }, options);
      }
      const sortForm = this.querySelector('.ca-sort');
      sortForm.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(location.href);
        url.searchParams.set('sort_by', sortForm.querySelector('select').value);
        url.searchParams.delete('page');
        url.hash = this.querySelector('.ca-shop').id;
        location.assign(url.href);
      }, options);
      this.querySelector('.ca-motion').addEventListener('click', event => {
        const paused = this.classList.toggle('is-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.textContent = paused ? '▶' : 'Ⅱ';
        this.querySelector('.ca-jewelry').style.setProperty('--px', '0px');
        this.querySelector('.ca-jewelry').style.setProperty('--py', '0px');
      }, options);
      const hero = this.querySelector('.ca-hero');
      const jewelry = this.querySelector('.ca-jewelry');
      hero.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || this.classList.contains('is-paused') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = hero.getBoundingClientRect();
        jewelry.style.setProperty('--px', `${(event.clientX - rect.left - rect.width / 2) * .012}px`);
        jewelry.style.setProperty('--py', `${(event.clientY - rect.top - rect.height / 2) * .012}px`);
      }, options);
      hero.addEventListener('pointerleave', () => {
        jewelry.style.setProperty('--px', '0px');
        jewelry.style.setProperty('--py', '0px');
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssa-pins-jewel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pj-showcase'))customElements.define('pj-showcase',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-piece]');if(!button)return;this.querySelectorAll('[data-piece]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.querySelectorAll('[data-panel]').forEach(panel=>panel.hidden=panel.dataset.panel!==button.dataset.piece)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssa-product-extras"]) return;
  try {
    
if (!customElements.get('ssa-product-find')) {
  customElements.define('ssa-product-find', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      if (this.querySelector('.ssa-find-card')) this.setup();
      else this.load();
    }
    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('.ssa-find-content');
        if (!content?.querySelector('.ssa-find-card')) return;
        this.replaceChildren(content);
        content.hidden = false;
        this.setup();
      } catch {}
    }
    setup() {
      this.cards = [...this.querySelectorAll('.ssa-find-card')];
      this.index = 0;
      this.querySelector('[data-find-total]').textContent = this.cards.length;
      this.querySelector('.ssa-find-controls').hidden = this.cards.length < 2;
      this.querySelector('[data-find-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-find-next]').addEventListener('click', () => this.show(this.index + 1));
      this.show(0);
    }
    show(index) {
      this.index = (index + this.cards.length) % this.cards.length;
      this.cards.forEach((card, i) => { card.hidden = i !== this.index; });
      this.querySelector('[data-find-current]').textContent = this.index + 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssa-stationery-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssa-stationery-collection')) {
    customElements.define('ssa-stationery-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('popstate', this.restore);
          return;
        }
        this.initialized = true;
        this.grid = this.querySelector('[data-stationery-grid]');
        this.controls = this.querySelector('[data-stationery-controls]');
        this.count = this.querySelector('[data-stationery-count]');
        this.empty = this.querySelector('[data-stationery-empty]');
        this.loadingNotice = this.querySelector('[data-stationery-loading]');
        this.errorNotice = this.querySelector('[data-stationery-error]');
        this.pagination = this.querySelector('[data-stationery-pagination]');
        this.nextUrl = this.dataset.nextUrl;
        this.categoryKeys = ['all', 'notebooks', 'notepads', 'post-it-notes', 'stickers', 'washi-tape'];
        this.restore = () => {
          if (this.ready) this.applyCategory(this.categoryFromUrl(), false);
        };
        window.addEventListener('popstate', this.restore);
        this.controls.hidden = false;
        this.addEventListener('click', event => {
          const categoryButton = event.target.closest('[data-stationery-category]');
          if (categoryButton && !categoryButton.disabled && this.ready) {
            this.applyCategory(categoryButton.dataset.stationeryCategory, true);
          }
          if (event.target.closest('[data-stationery-retry]')) this.loadCatalog();
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-stationery-select]') && this.ready) {
            this.applyCategory(event.target.value, true);
          }
          if (event.target.matches('[data-stationery-sort]')) {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', event.target.value);
            url.searchParams.delete('page');
            url.searchParams.delete('section_id');
            window.location.assign(url.href);
          }
        });
        this.loadCatalog();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.restore);
      }

      categoryFromUrl() {
        const key = new URL(window.location.href).searchParams.get('stationery_category');
        return this.categoryKeys.includes(key) ? key : 'all';
      }

      async fetchPage(url) {
        const requestUrl = new URL(url, window.location.origin);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(requestUrl.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const collectionSection = documentFragment.querySelector('ssa-stationery-collection');
        if (!collectionSection) throw new Error('Collection section missing');
        return collectionSection;
      }

      async loadCatalog() {
        if (this.loading) return;
        this.loading = true;
        this.errorNotice.hidden = true;
        this.grid.setAttribute('aria-busy', 'true');
        try {
          const firstUrl = new URL(this.dataset.collectionUrl, window.location.origin);
          firstUrl.search = window.location.search;
          let resetNeeded = Number(this.dataset.page) > 1 || firstUrl.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '');
          for (const key of Array.from(firstUrl.searchParams.keys())) {
            if (key.startsWith('filter.')) {
              firstUrl.searchParams.delete(key);
              resetNeeded = true;
            }
          }
          firstUrl.searchParams.delete('page');
          firstUrl.searchParams.delete('section_id');
          if (resetNeeded && !this.resetComplete) {
            this.loadingNotice.hidden = false;
            const firstPage = await this.fetchPage(firstUrl.href);
            this.grid.replaceChildren(...Array.from(firstPage.querySelectorAll('[data-stationery-item]')));
            this.nextUrl = firstPage.dataset.nextUrl;
            this.resetComplete = true;
          }
          const visited = new Set();
          while (this.nextUrl) {
            this.loadingNotice.hidden = false;
            if (visited.has(this.nextUrl)) throw new Error('Repeated collection page');
            visited.add(this.nextUrl);
            const nextPage = await this.fetchPage(this.nextUrl);
            if (!this.isConnected) return;
            const existing = new Set(Array.from(this.grid.querySelectorAll('[data-stationery-item]')).map(item => item.dataset.productHandle));
            for (const item of nextPage.querySelectorAll('[data-stationery-item]')) {
              if (!existing.has(item.dataset.productHandle)) this.grid.append(item);
            }
            this.nextUrl = nextPage.dataset.nextUrl;
          }
          this.items = Array.from(this.grid.querySelectorAll('[data-stationery-item]'));
          this.ready = true;
          this.dataset.ready = 'true';
          for (const control of this.controls.querySelectorAll('button, select')) control.disabled = false;
          if (this.pagination) this.pagination.hidden = true;
          this.applyCategory(this.categoryFromUrl(), false);
        } catch {
          if (this.isConnected) this.errorNotice.hidden = false;
        } finally {
          this.loading = false;
          this.loadingNotice.hidden = true;
          this.grid.setAttribute('aria-busy', 'false');
        }
      }

      applyCategory(category, updateUrl) {
        if (!this.categoryKeys.includes(category)) category = 'all';
        let count = 0;
        for (const item of this.items) {
          const visible = category === 'all' || item.dataset.categories.split(/\s+/).includes(category);
          item.hidden = !visible;
          if (visible) count += 1;
        }
        for (const button of this.querySelectorAll('[data-stationery-category]')) {
          button.setAttribute('aria-pressed', String(button.dataset.stationeryCategory === category));
        }
        this.querySelector('[data-stationery-select]').value = category;
        this.querySelector('[data-stationery-selected]').value = category;
        this.count.textContent = count === 1 ? this.dataset.countOne : this.dataset.countOther.replace('__COUNT__', String(count));
        this.empty.hidden = count !== 0;
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.pathname = this.dataset.collectionUrl;
          url.searchParams.delete('page');
          for (const key of Array.from(url.searchParams.keys())) {
            if (key.startsWith('filter.')) url.searchParams.delete(key);
          }
          if (category === 'all') url.searchParams.delete('stationery_category');
          else url.searchParams.set('stationery_category', category);
          if (url.href !== window.location.href) window.history.pushState({}, '', url.href);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
